import React from 'react';
import Text from '../../../../text';
import Row from '../../../../row';
import CardFooter from '../../card-footer';
import styles from './styles.module.scss';

var Footer = function Footer(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement(CardFooter, null, /*#__PURE__*/React.createElement(Row, {
    direction: "column",
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Row, {
    direction: "row",
    className: styles.full
  }, content.map(function (_ref2) {
    var title = _ref2.title,
        subTitle = _ref2.subTitle;
    return /*#__PURE__*/React.createElement(Row, {
      direction: "column",
      key: title,
      style: {
        width: "".concat(100 / content.length, "%")
      }
    }, /*#__PURE__*/React.createElement(Text, {
      as: "p",
      size: "lg",
      weight: "semi-bold",
      truncate: true,
      className: styles.full
    }, title), /*#__PURE__*/React.createElement(Text, {
      as: "p",
      size: "md",
      truncate: true,
      className: styles.full
    }, subTitle));
  }))));
};

export default Footer;